module.exports = __webpack_public_path__ + "static/media/e-boks_sandbox.0d8b3416.svg";